import { useMemo } from "react";
import { ArticleStatus } from "../../__generated__/gql/graphql";
import Badge, { BadgeColor } from "../../ui/Badge/Badge";
import {
  FragmentType,
  getFragmentData,
  graphql,
} from "../../__generated__/gql";

export const StatusBadgeFragment = graphql(/* GraphQL */ `
  fragment StatusBadge on HasStatus {
    status
    processingMessage
  }
`);

function formatArticleStatus(status: ArticleStatus): string {
  switch (status) {
    case ArticleStatus.Draft:
      return "Draft";
    case ArticleStatus.Published:
      return "Published";
    case ArticleStatus.Generated:
      return "Generated";
    case ArticleStatus.Processing:
      return "Processing";
    case ArticleStatus.Error:
      return "Error";
    default:
      return "Unknown";
  }
}

export default function StatusBadge({
  data,
}: {
  data: FragmentType<typeof StatusBadgeFragment>;
}) {
  const { status, processingMessage } = getFragmentData(
    StatusBadgeFragment,
    data,
  );

  const color: BadgeColor = useMemo(() => {
    switch (status) {
      case ArticleStatus.Draft:
        return "default";
      case ArticleStatus.Published:
        return "success";
      case ArticleStatus.Generated:
        return "info";
      case ArticleStatus.Processing:
        return "purple";
      case ArticleStatus.Error:
        return "error";
      default:
        return "default";
    }
  }, [status]);
  return (
    <Badge color={color} loading={status === ArticleStatus.Processing}>
      {status === ArticleStatus.Processing && processingMessage
        ? processingMessage
        : formatArticleStatus(status)}
    </Badge>
  );
}
